// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import VueSimpleSVG from 'vue-simple-svg'
import * as VueGoogleMaps from "vue2-google-maps";

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

Vue.use(VueSimpleSVG)

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyC0qC_vXQQxcSdrKTpmkZ28tXUNu34aIHw",
    libraries: "places" // necessary for places input
  }
})



// WEBPACK FOOTER //
// ./src/main.js